export default {
  // 頁面標題
  pageTitle: "AI模型",

  // 按鈕
  addModel: "添加模型",
  reset: "重置",
  query: "查詢",
  download: "下載",

  // 搜索區域
  selectCaseName: "請選擇案件名稱",
  inputAddress: "請輸入地址",

  // 統計信息
  totalCount: "共計",
  totalData: "條數據",
  selected: "已選擇",
  items: "項",

  // 加載提示
  loading: "拼命加載中",

  // 表格列名
  serialNumber: "序號",
  caseName: "案件名稱",
  blockchain: "公鏈",
  address: "地址",
  model: "模型",
  creator: "創建人",
  time: "時間",
  status: "狀態",
  operation: "操作",

  // 狀態
  verified: "已驗證",
  toBeVerified: "待驗證",

  // 操作按鈕
  view: "查看",
  normalSurvey: "普通調證",
  keySurvey: "重點調證",
  delete: "刪除",

  // 對話框
  verificationResult: "驗證結果",
  tip: "提示",
  confirmDownload: "是否下載已選中的模型驗證結果？",
  yes: "是",
  no: "否",
  confirmDeleteAddress: "是否要刪除此條地址?",
  confirm: "確定",
  cancel: "取消",

  // 消息提示
  copySuccess: "複製成功",
  deleteSuccess: "刪除成功",
  deleteCancel: "已取消刪除",

  // 新手引導
  guideStep1: "點擊添加模型驗證",
  guideStep2: "模型驗證列表，點擊【查看結果】可以查看涉案地址手續費來源。",
};
